export const isCurrentLink = url => {
    const hash = window.location.hash === '#gallery' ? '' : window.location.hash;
    return window.location.pathname + hash === url;
};

export const toggleClass = (element, state, className) => {
    state ? element.classList.add(className) : element.classList.remove(className);
};
